var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkOneAsRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification_multiple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "notification_multiple_2",
    d: "M9.63196 13.0053L1.69971 8.35926V15.9516C1.69971 16.0533 1.7324 16.1368 1.79779 16.2022C1.86317 16.2676 1.94672 16.3003 2.04842 16.3003H17.2155C17.3172 16.3003 17.4008 16.2676 17.4661 16.2022C17.5315 16.1368 17.5642 16.0533 17.5642 15.9516V8.35926L9.63196 13.0053ZM2.04842 18C1.47601 18 0.991512 17.8017 0.594919 17.4051C0.198306 17.0085 0 16.524 0 15.9516V6.77723C0 6.43146 0.0733639 6.11548 0.220092 5.8293C0.366819 5.54309 0.601444 5.30701 0.923965 5.12106L9.63196 0L12.0487 1.42517L10.7848 2.65419L9.63196 1.98737L1.92635 6.52008L9.63196 11.0528L17.3376 6.52008L15.7533 5.56994L16.9824 4.34089L18.34 5.12106C18.6625 5.30701 18.8971 5.54309 19.0439 5.8293C19.1906 6.11548 19.2639 6.43146 19.2639 6.77723V15.9516C19.2639 16.524 19.0656 17.0085 18.669 17.4051C18.2724 17.8017 17.7879 18 17.2155 18H2.04842ZM9.41841 9.1743L6.63779 6.39368L7.83196 5.1995L9.41841 6.78595L14.6877 1.51667L15.8819 2.71085L9.41841 9.1743Z",
    fill: "#1D4650"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkOneAsRead);
export default __webpack_public_path__ + "static/media/mark-one-as-read.44d3ab1c24c2a5d445edcb9840bc5e23.svg";
export { ForwardRef as ReactComponent };